import React from "react";
import { Toast } from "@sscs/ui";
import { Dialog } from "Components";
import { GroupUsage } from "Types";
import { apiErrorToast } from "Utils";
import { useDeleteGroupUsageLimitMutation } from "../../services/licensing.api";

type RemoveLimitProps = {
  groupUsage: NonNullable<GroupUsage>;
  isOpen: boolean;
  onClose: () => void;
};

const RemoveLimit = ({
  groupUsage,
  isOpen,
  onClose,
}: RemoveLimitProps): React.JSX.Element => {
  const [removeGroupUsageLimit] = useDeleteGroupUsageLimitMutation();

  const handleRemove = async () => {
    try {
      await removeGroupUsageLimit({
        body: { group_ids: [groupUsage.group_id] },
      }).unwrap();

      Toast.show({
        title: "Removed usage limit for group",
        type: "success",
      });
    } catch (error) {
      apiErrorToast(error, "Could not remove usage limit for group");
    }

    onClose();
  };

  return (
    <Dialog
      title={
        <>
          Remove usage limit for <b>{groupUsage.group_name} group</b>
        </>
      }
      isOpen={isOpen}
      confirmText="Remove"
      onConfirm={handleRemove}
      onCancel={onClose}
      onClose={onClose}
    >
      Are you sure you want to remove this limit?
    </Dialog>
  );
};

export default RemoveLimit;
